export const KEY_FAILED_CHECK_INS = 'KEY_FAILED_CHECK_INS';
